// extracted by mini-css-extract-plugin
export default {"box_noaccess":"NoAccess_box_noaccess__9vBql","container_select_company":"NoAccess_container_select_company__TNzg4"};